import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';

/**
 * Portaled to document.body so it escapes the calendar header's stacking context
 * (in weekView the header is position: fixed / z-index: 99 and would otherwise trap
 * the tooltip beneath the icon sidebar). Styled to match the exercise-sidebar tooltip:
 * white bubble, dark text, visible caret, wraps at 300px (fits the screen when smaller).
 */
const CalendarNameTooltip = ({ id }) => createPortal(
  <ReactTooltip
    id={id}
    variant='light'
    place='bottom'
    opacity={1}
    border='1px solid #E0E0E0'
    style={{
      backgroundColor: '#ffffff',
      color: '#444444',
      fontFamily: 'Nunito Sans',
      fontSize: '13px',
      fontWeight: 400,
      maxWidth: 'min(300px, calc(100vw - 32px))',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      textAlign: 'center',
      borderRadius: '6px',
      padding: '8px',
      boxShadow: '0px 0px 1px rgb(48 49 51 / 5%), 0px 4px 8px rgb(48 49 51 / 10%)',
      zIndex: 1000,
    }}
  />,
  document.body,
);

CalendarNameTooltip.propTypes = {
  id: PropTypes.string.isRequired,
};

export default CalendarNameTooltip;
